var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"search-btn",class:{ 'search-btn--with-banner': _vm.bannerVisible },on:{"click":_vm.onBtnClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }